export default __webpack_public_path__ + "3699468e1a49cd8fe5ac3fc267db2408.png";